export const DASH = {
  EN: '–',
  EM: '—',
}
